export default {
  MODAL_SMALL_WIDTH: 318, // in px
  MODAL_MEDIUM_WIDTH: 375, // in px
  MODAL_LARGE_WIDTH: 416, // in px
  MODAL_HEADER_HEIGHT: 48, // in px
  MODAL_FOOTER_HEIGHT: 48, // in px
};
